/*
 * 此文件是用canvas 画标尺，横纵坐标分为两个canvas进行展示
 *  params ={
 *        horizontalDom : 横坐标canvas 的Id （必填）
 *        verticalDom: 纵坐标canvas 的Id（必填）
 *        zoom: 缩放比例
 *        tickColor: 刻度尺的颜色
 *        axisColor: 轴线颜色
 *        horTickSpacing: 横坐标刻度尺间距
 *        verTickSpacing: 纵坐标刻度尺间距
 *    }
 *
 */
export function canvasRuler(params) {
  this.zoom = params.zoom || 1
  this.horizontalDom = params.horizontalDom
  this.verticalDom = params.verticalDom

  this.AXIS_MARGIN_left = params.axisMarginLeft || 0
  this.AXIS_MARGIN_top = params.axisMarginTop || 0
  this.AXIS_MARGIN = 0
  this.HORIZONTAL_TICK_SPACING = params.horTickSpacing || 10
  this.VERTICAL_TICK_SPACING = params.verTickSpacing || 10
  this.TICK_WIDTH = 6
  this.TICKS_LINEWIDTH = 1
  this.TICKS_COLOR = params.tickColor || "#999"
  this.AXIS_LINEWIDTH = 1
  this.AXIS_COLOR = params.axisColor || "#999"

  this.horizontalCanvas = document.getElementById(this.horizontalDom)
  this.horizontalContext = this.horizontalCanvas.getContext("2d")
  this.verticalCanvas = document.getElementById(this.verticalDom)
  this.verticalContext = this.verticalCanvas.getContext("2d")

  this.AXIS_ORIGIN_H = { x: this.AXIS_MARGIN, y: this.AXIS_MARGIN, w: this.horizontalCanvas.width }
  this.AXIS_ORIGIN_V = {
    x: this.AXIS_MARGIN + this.verticalCanvas.width,
    y: this.AXIS_MARGIN,
    w: this.verticalCanvas.width,
    h: this.verticalCanvas.height
  }

  this.AXIS_RIGHT = this.horizontalCanvas.width - this.AXIS_MARGIN
  this.AXIS_WIDTH = this.AXIS_RIGHT - this.AXIS_ORIGIN_H.x
  this.NUM_VERTICAL_TICKS = parseInt(this.verticalCanvas.height / this.VERTICAL_TICK_SPACING / this.zoom)
  this.NUM_HORIZONTAL_TICKS = parseInt(this.AXIS_WIDTH / this.HORIZONTAL_TICK_SPACING / this.zoom)
}

canvasRuler.prototype = {
  constructor: canvasRuler,
  init: function () {
    this.horizontalContext.clearRect(0, 0, this.horizontalCanvas.width, this.horizontalCanvas.height)
    this.verticalContext.clearRect(0, 0, this.verticalCanvas.width, this.verticalCanvas.height)
    this.initH()
    this.initV()
  },
  initV: function () {
    let context = this.verticalContext
    context.save()
    context.strokeStyle = this.AXIS_COLOR
    context.lineWidth = this.AXIS_LINEWIDTH
    this.drawVerticalAxis(context)
    context.lineWidth = 0.5
    context.lineWidth = this.TICKS_LINEWIDTH
    context.strokeStyle = this.TICKS_COLOR
    this.drawVerticalAxisTicks(context)
    context.restore()
  },
  initH: function () {
    let context = this.horizontalContext
    context.save()
    context.strokeStyle = this.AXIS_COLOR
    context.lineWidth = this.AXIS_LINEWIDTH
    this.drawHorizontalAxis(context)
    context.lineWidth = 0.5
    context.lineWidth = this.TICKS_LINEWIDTH
    context.strokeStyle = this.TICKS_COLOR
    this.drawHorizontalAxisTicks(context)
    context.restore()
  },
  drawHorizontalAxis: function (context) {
    context.beginPath()
    context.moveTo(this.AXIS_ORIGIN_H.x, this.AXIS_ORIGIN_H.y)
    context.lineTo(this.AXIS_ORIGIN_H.w, this.AXIS_ORIGIN_H.y)
    context.strokeStyle = this.TICKS_COLOR
    context.lineWidth = 0.5
    context.closePath()
    context.stroke()
  },
  drawHorizontalAxisTicks: function (context) {
    let deltaY
    for (let i = 0; i < this.NUM_HORIZONTAL_TICKS; ++i) {
      context.beginPath()
      if (i % 5 === 0) {
        let showText = true
        deltaY = this.TICK_WIDTH
        if (this.zoom < 0.5) {
          showText = i % 50 === 0 ? true : false
        }
        if (showText) {
          context.fillText(
            i * this.HORIZONTAL_TICK_SPACING + this.AXIS_MARGIN_left,
            this.HORIZONTAL_TICK_SPACING * i * this.zoom,
            15,
            16
          )
        }
      } else {
        deltaY = this.TICK_WIDTH / 2
      }
      context.moveTo((this.AXIS_ORIGIN_H.x + i * this.HORIZONTAL_TICK_SPACING) * this.zoom, this.AXIS_MARGIN)
      context.lineTo((this.AXIS_ORIGIN_H.x + i * this.HORIZONTAL_TICK_SPACING) * this.zoom, this.AXIS_MARGIN + deltaY)
      context.lineWidth = 1
      context.fillStyle = this.AXIS_COLOR
      context.stroke()
    }
  },
  drawVerticalAxis: function (context) {
    context.beginPath()
    context.moveTo(this.AXIS_ORIGIN_V.x, this.AXIS_ORIGIN_V.y)
    context.lineTo(this.AXIS_ORIGIN_V.x, this.AXIS_ORIGIN_V.h)
    context.closePath()
    context.stroke()
  },
  drawVerticalAxisTicks: function (context) {
    let deltaX
    for (let i = 0; i < this.NUM_VERTICAL_TICKS; ++i) {
      context.beginPath()
      if (i % 5 === 0) {
        let showText = true
        if (this.zoom < 0.5) {
          showText = i % 50 === 0 ? true : false
        }
        if (showText) {
          let text = (i * this.VERTICAL_TICK_SPACING + this.AXIS_MARGIN_top).toString()
          deltaX = this.TICK_WIDTH
          context.textAlign = "left"
          context.fillText(
            text,
            this.AXIS_ORIGIN_V.x - this.AXIS_ORIGIN_V.w,
            this.VERTICAL_TICK_SPACING * i * this.zoom + 10,
            16
          )
        }
      } else {
        deltaX = this.TICK_WIDTH / 2
      }
      context.moveTo(this.AXIS_ORIGIN_V.x, i * this.VERTICAL_TICK_SPACING * this.zoom)
      context.lineTo(this.AXIS_ORIGIN_V.x - deltaX, i * this.VERTICAL_TICK_SPACING * this.zoom)
      context.fillStyle = this.AXIS_COLOR
      context.stroke()
    }
  }
}
